import { render, staticRenderFns } from "./configLinkAdd.vue?vue&type=template&id=184a9480&"
import script from "./configLinkAdd.vue?vue&type=script&lang=js&"
export * from "./configLinkAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports